/**
 * API client for the project activity log.
 */

import { apiRequest } from "./client";

/* ---------- Types ---------- */

export interface ActivityLogEntry {
  id: string;
  project: string;
  actor_type: "user" | "agent" | "system";
  actor_id: string;
  action: string;
  target_type: string;
  target_id: string;
  details: Record<string, unknown>;
  task: string | null;
  task_ticket: string | null;
  created_at: string;
}

interface ApiResponse<T> {
  status: string;
  data: T;
}

/* ---------- Endpoints ---------- */

export async function listActivity(
  projectId: string,
  opts: {
    limit?: number;
    action?: string;
    actor_type?: string;
  } = {},
): Promise<ActivityLogEntry[]> {
  const params = new URLSearchParams();
  if (opts.limit !== undefined) params.set("limit", String(opts.limit));
  if (opts.action) params.set("action", opts.action);
  if (opts.actor_type) params.set("actor_type", opts.actor_type);
  const qs = params.toString();
  const url = `/api/v1/projects/${projectId}/activity/${qs ? `?${qs}` : ""}`;
  const res = await apiRequest<ApiResponse<ActivityLogEntry[]>>(url);
  return res.data;
}
